import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import {
  fetchNotifications,
  deleteNotifications,
  bulkDeleteNotifications,
  exportEmptyData,
} from "../../Actions/Dashboard/dashboardActions.js";
import {
  showFormattedDate,
  autoScrolling,
  isFormSubmit,
} from "../../Utils/services.js";
import { uiNotification } from "../../services/UINotificationService.js";
import { DateRangePicker } from "../../shared/DateRangePicker/DateRangePicker";
import { API_DATE_FORMAT } from "../../consts/api";
import "./Notifications.scss";

const SCROLL_THRESHOLD_PX = 5;
const DEFAULT_PAGE_SIZE = 20;
const INITIAL_PAGE = 1;

class Notifications extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    const userData = JSON.parse(localStorage.getItem("userData"));

    this.state = {
      firstname: "",
      lastname: "",
      from_number: "",
      message: "",
      created: "",
      is_juvly_account: 0,
      getNotificationData: [],
      notification_message: "",
      smsNotificationname: true,
      Notificationname: false,
      showModal: false,
      userId: "",
      showLoadingText: false,
      id: userData.user.id,
      fetchNotificationData: [],
      page: INITIAL_PAGE,
      pagesize: DEFAULT_PAGE_SIZE,
      sortorder: "asc",
      term: "",
      hasMoreItems: true,
      next_page_url: "",
      loadMore: true,
      startFresh: true,
      showLoader: false,
      scopes: "business_hours",
      isDeleting: false,
      responseData: {},
      selected: [],
      innerbox_select_all: false,
      periodFrom: null,
      periodTo: null,
      sortOnly: false,
      loadFresh: false,
      shouldResetUnreadCount: false,
    };

    localStorage.setItem("loadFresh", false);
    localStorage.setItem("sortOnly", false);

    window.addEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const scrollTop = parseInt(
      Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop,
      ),
    );
    const shouldLoadMore =
      document.documentElement.offsetHeight -
        (window.innerHeight + scrollTop) <=
        SCROLL_THRESHOLD_PX && this.state.next_page_url !== null;
    if (shouldLoadMore) {
      this.loadMore();
    }
  };

  loadMore = () => {
    if (!autoScrolling()) {
      autoScrolling(true);
      localStorage.setItem("sortOnly", false);
      this.setState({
        loadMore: true,
        startFresh: true,
        showLoader: true,
        showLoadingText: true,
        sortOnly: false,
      });

      let formData = {
        params: {
          page: this.state.page,
          pagesize: this.state.pagesize,
          sortorder: this.state.sortorder,
          scopes: this.state.scopes,
        },
      };

      if (this.state.periodFrom && this.state.periodTo) {
        formData.params.fromDate = this.formatDate(this.state.periodFrom);
        formData.params.toDate = this.formatDate(this.state.periodTo);
      }

      autoScrolling(true);
      this.props.fetchNotifications(formData);
    }
  };

  showEditModal = (e) => {
    this.setState({ userId: e.currentTarget.dataset.userid });
  };

  dismissModal = () => {
    this.setState({ showModal: false });
  };

  handleAllChecked = (e) => {
    const { checked } = e.target;
    const allIds = this.state.getNotificationData?.map((item) => item.id) || [];
    this.setState({
      innerbox_select_all: checked,
      selected: checked ? allIds : [],
    });
  };

  handleChecked = (id, e) => {
    const { checked } = e.target;
    const newSelected = [...this.state.selected];

    if (checked) {
      if (!newSelected.includes(id)) {
        newSelected.push(id);
      }
    } else {
      const idx = newSelected.indexOf(id);
      if (idx > -1) {
        newSelected.splice(idx, 1);
      }
    }

    const allIds = this.state.getNotificationData?.map((item) => item.id) || [];
    const selectAll = allIds.length > 0 && newSelected.length === allIds.length;

    this.setState({
      selected: newSelected,
      innerbox_select_all: selectAll,
    });
  };

  formatDate = (d) => {
    return d ? moment(d).format(API_DATE_FORMAT) : "";
  };

  resetPaginationState = () => {
    return {
      page: INITIAL_PAGE,
      loadMore: true,
      startFresh: true,
      next_page_url: "",
      getNotificationData: [],
      showLoader: true,
      sortOnly: true,
    };
  };

  onPeriodChange = ({ startDate, endDate }) => {
    this.setState(
      {
        periodFrom: startDate || null,
        periodTo: endDate || null,
      },
      () => {
        if (startDate && endDate) {
          const params = {
            page: INITIAL_PAGE,
            pagesize: this.state.pagesize,
          };
          if (this.state.periodFrom && this.state.periodTo) {
            params.fromDate = this.formatDate(this.state.periodFrom);
            params.toDate = this.formatDate(this.state.periodTo);
          }

          this.setState(this.resetPaginationState());
          autoScrolling(true);
          this.props.fetchNotifications({ params });
        }
      },
    );
  };

  handleBulkDelete = () => {
    if (!isFormSubmit()) {
      uiNotification.warning("Please wait a moment before trying again");
      return;
    }

    if (this.state.selected.length === 0) {
      uiNotification.error(
        "Please select at least one notification to delete.",
      );
      return;
    }

    this.props.exportEmptyData();
    this.setState({
      isDeleting: true,
      ...this.resetPaginationState(),
    });
    autoScrolling(true);

    this.props
      .bulkDeleteNotifications(this.state.selected)
      .then(() => {
        return this.props.fetchNotifications({
          params: {
            page: INITIAL_PAGE,
            pagesize: this.state.pagesize,
          },
        });
      })
      .then(() => {
        uiNotification.success("Notifications have been successfully deleted");
        this.setState({
          selected: [],
          innerbox_select_all: false,
        });
      })
      .catch((error) => {
        const errorMessage =
          error?.message === "validation_user_notification_id_exists"
            ? "You do not have permission to delete these notifications"
            : "Unable to delete notifications. Please try again later";

        uiNotification.error(errorMessage);
      })
      .finally(() => {
        this.setState({
          showLoader: false,
          isDeleting: false,
        });
      });
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);

    autoScrolling(true);

    let formData = {
      params: {
        page: this.state.page,
        pagesize: this.state.pagesize,
      },
    };
    if (this.state.periodFrom && this.state.periodTo) {
      formData.params.fromDate = this.formatDate(this.state.periodFrom);
      formData.params.toDate = this.formatDate(this.state.periodTo);
    }

    const languageData = JSON.parse(localStorage.getItem("languageData"));
    this.setState({
      SMS_Notifications: languageData.dashboard["SMS_Notifications"],
      Notifications: languageData.dashboard["Notifications"],
      SMS_Notifications_All_Time_displayed:
        languageData.dashboard["SMS_Notifications_All_Time_displayed"],
      loading_please_wait_text: languageData.global["loading_please_wait_text"],
      SMS_Notifications_SMS: languageData.dashboard["SMS_Notifications_SMS"],
      clinic_Please_Wait: languageData.settings["clinic_Please_Wait"],
      dashboard_No_record_found:
        languageData.dashboard["dashboard_No_record_found"],
      showLoader: true,
    });
    this.setState({ showLoader: true });
    this.props.fetchNotifications(formData);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    this.setState({
      [event.target.name]: value,
    });
  };

  renderColorClass = (notificationType) => {
    switch (notificationType) {
      case "low_stock":
        return "user-status status-color-a";
      case "expired_stock":
        return "user-status status-color-b";
      case "appointment_sync_failed":
        return "user-status status-color-c";
      case "invoice":
        return "user-status status-color-d";
      default:
        return "user-status status-color-i";
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    localStorage.setItem("sortOnly", true);
    let formData = {
      params: {
        page: 1,
        pagesize: this.state.pagesize,
        sortorder: this.state.sortorder,
        scopes: this.state.scopes,
      },
    };

    this.setState({
      page: 1,
      pagesize: this.state.pagesize,
      sortorder: this.state.sortorder == "asc" ? "desc" : "asc",
      loadMore: true,
      startFresh: true,
      next_page_url: "",
      getNotificationData: [],
    });
    autoScrolling(true);
    this.props.fetchNotifications(formData);
  };

  onSort = (sortby) => {
    let sortorder = this.state.sortorder === "asc" ? "desc" : "asc";
    let formData = {
      params: {
        page: 1,
        pagesize: this.state.pagesize,
        sortby: sortby,
        sortorder: sortorder,
        term: this.state.term,
      },
    };
    this.setState({
      page: 1,
      pagesize: this.state.pagesize,
      sortby: sortby,
      sortorder: sortorder,
      loadMore: true,
      startFresh: true,
      showLoader: true,
      next_page_url: "",
      getNotificationData: [],
    });
    localStorage.setItem("sortOnly", true);
    autoScrolling(true);
    this.props.fetchNotifications(formData);
  };

  userEdit = (id) => {
    return <div>{this.props.history.push(`/settings/clinic/${id}/edit`)}</div>;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    let returnState = {};
    if (nextProps.showLoader !== undefined && nextProps.showLoader === false) {
      nextProps.exportEmptyData();
      return { showLoader: false };
    }
    if (
      nextProps.getNotificationData !== undefined &&
      nextProps.notificationTime !== prevState.notificationTime
    ) {
      nextProps.exportEmptyData();
      returnState.notificationTime = nextProps.notificationTime;
      if (prevState.next_page_url === null) {
        returnState.showLoader = false;
        returnState.next_page_url = null;
        returnState.sortOnly = false;
        localStorage.setItem("sortOnly", false);
        autoScrolling(false);
        return returnState;
      }

      if (
        prevState.getNotificationData.length === 0 &&
        prevState.startFresh === true
      ) {
        returnState.getNotificationData =
          nextProps.getNotificationData.data.data;
        if (nextProps.getNotificationData.data.next_page_url !== null) {
          returnState.page = prevState.page + 1;
        } else {
          returnState.next_page_url =
            nextProps.getNotificationData.data.next_page_url;
        }
        returnState.is_juvly_account =
          nextProps.getNotificationData.data.is_juvly_account;
        returnState.startFresh = false;
        returnState.showLoader = false;
        returnState.showLoadingText = false;

        if (!prevState.sortOnly) {
          returnState.shouldResetUnreadCount = true;
        }

        returnState.sortOnly = false;
      } else if (
        prevState.getNotificationData !==
          nextProps.getNotificationData.data.data &&
        prevState.getNotificationData.length !== 0
      ) {
        returnState.getNotificationData = [
          ...prevState.getNotificationData,
          ...nextProps.getNotificationData.data.data,
        ];
        returnState.page = prevState.page + 1;
        returnState.next_page_url =
          nextProps.getNotificationData.data.next_page_url;
        returnState.is_juvly_account =
          nextProps.getNotificationData.data.is_juvly_account;
        returnState.showLoader = false;
        returnState.showLoadingText = false;
      }
      if (returnState.page) {
        autoScrolling(false);
      }
      return returnState;
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.shouldResetUnreadCount &&
      !prevState.shouldResetUnreadCount
    ) {
      const unreadNotificationCount = document.getElementById(
        "unread-notification-count",
      );
      if (unreadNotificationCount) {
        unreadNotificationCount.innerHTML = "";
        unreadNotificationCount.classList.add("no-display");
      }
      this.setState({ shouldResetUnreadCount: false });
    }
  }

  render() {
    const isLoggedIn = Boolean(localStorage.getItem("userData"));

    return (
      <div id="content">
        <div className="container-fluid content setting-wrapper">
          <div className="title">
            <span>{this.state.Notifications}</span>
          </div>
          <div className="juvly-section full-width">
            <div className="setting-search-outer">
              <div className="d-flex align-center justify-between">
                <div className="d-flex align-center">
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={this.handleBulkDelete}
                    disabled={
                      !isLoggedIn ||
                      this.state.selected.length === 0 ||
                      this.state.isDeleting
                    }
                  >
                    {this.state.isDeleting
                      ? "Deleting..."
                      : `Delete (${this.state.selected.length})`}
                  </button>
                </div>
                <div className="d-flex align-center">
                  {this.state.getNotificationData &&
                    this.state.getNotificationData.length > 0 && (
                      <span className="search-text m-r-10">
                        {this.state.SMS_Notifications_All_Time_displayed}
                      </span>
                    )}
                  <DateRangePicker
                    size="small"
                    dateFormat={"YYYY-MM-DD"}
                    onChange={this.onPeriodChange}
                    value={{
                      startDate: this.state.periodFrom,
                      endDate: this.state.periodTo,
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="activity-outer delete-activity">
              <div className="activity-row activity-row-header d-flex align-center">
                <div className="activity-checkbox m-r-10">
                  <input
                    type="checkbox"
                    checked={this.state.innerbox_select_all}
                    onChange={this.handleAllChecked}
                  />
                </div>
                <div className="header-col type-col">Type</div>
                <div className="header-col notification-col">Notification</div>
                <div className="header-col date-col">Date</div>
              </div>

              {this.state.getNotificationData &&
                this.state.getNotificationData.length > 0 &&
                this.state.getNotificationData.map((obj, idx) => {
                  return (
                    <div className="activity-row cursor-pointer" key={idx}>
                      <input
                        type="checkbox"
                        checked={this.state.selected.indexOf(obj.id) > -1}
                        onChange={(e) => {
                          e.stopPropagation();
                          this.handleChecked(obj.id, e);
                        }}
                      />
                      <div
                        className={this.renderColorClass(obj.notification_type)}
                      >
                        {obj.notification_type.replace(/_/g, " ").toUpperCase()}
                      </div>
                      <div
                        className="activity-detail"
                        dangerouslySetInnerHTML={{
                          __html: obj.notification_message,
                        }}
                      ></div>
                      <div className="activity-time">
                        {showFormattedDate(obj.created, false)}
                      </div>
                    </div>
                  );
                })}
              {(this.state.getNotificationData === undefined ||
                (this.state.getNotificationData.length === 0 &&
                  this.state.showLoader === false)) && (
                <div className="no-record p-b-40">
                  {this.state.dashboard_No_record_found}{" "}
                </div>
              )}
            </div>
            <div
              className={
                this.state.showLoader
                  ? "new-loader text-left displayBlock"
                  : "new-loader text-left"
              }
            >
              <div className="loader-outer">
                <img
                  id="loader-outer"
                  src="/images/Eclipse.gif"
                  className="loader-img"
                  alt=""
                />
                <div id="modal-confirm-text" className="popup-subtitle">
                  {this.state.clinic_Please_Wait}
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              this.state.showLoadingText
                ? "loading-please-wait"
                : "loading-please-wait no-display "
            }
          >
            {this.state.loading_please_wait_text}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const languageData = JSON.parse(localStorage.getItem("languageData")) || {
    global: {},
  };
  const returnState = {};
  localStorage.setItem("sortOnly", false);
  if (state.DashboardReducer?.action === "NOTIFICATION_LIST") {
    if (state.DashboardReducer.data?.status !== 200) {
      uiNotification.clear();
      uiNotification.error(
        languageData.global[state.DashboardReducer.data.message],
      );
      returnState.showLoader = false;
    } else {
      returnState.getNotificationData = state.DashboardReducer.data;
      returnState.notificationTime = new Date();
    }
  } else if (state.DashboardReducer.action === "DELETE_NOTIFICATION_DATA") {
    localStorage.setItem("isDelete", false);
  }
  return returnState;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchNotifications: fetchNotifications,
      deleteNotifications: deleteNotifications,
      bulkDeleteNotifications: bulkDeleteNotifications,
      exportEmptyData: exportEmptyData,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
